import axios from 'axios'
import router from '@/router/index'
import store from '@/store/store'
import config from '@/config'
import {Loading, Message} from 'element-ui'

axios.defaults.timeout = config.timeout;
// axios.defaults.baseURL = sessionStorage.hostLogin || '//' + location.host;


// 根据不同的状态码，生成不同的提示信息
const showStatus = (status) => {
  let message = ''
  switch (status) {
    case 400:
      message = '请求错误(400)'
      break;
    case 401:
      message = '未授权，请重新登录(401)'
      break;
    case 403:
      message = '拒绝访问(403)'
      break;
    case 404:
      message = '请求出错(404)'
      break;
    case 408:
      message = '请求超时(408)'
      break;
    case 500:
      message = '服务器错误(500)'
      break;
    case 501:
      message = '服务未实现(501)'
      break;
    case 502:
      message = '网络错误(502)'
      break;
    case 503:
      message = '服务不可用(503)'
      break;
    case 504:
      message = '网络超时(504)'
      break;
    case 505:
      message = 'HTTP版本不受支持(505)'
      break;
    default:
      message = `连接出错(${status})!`
  }
  return message;
};


//http request 拦截器
axios.interceptors.request.use(config => {
  //请求头设置
  if (!store.state.token && store.state.token != undefined) {
    config.headers["token"] = store.state.token;
  } else {
    config.headers["token"] = localStorage.token;
  }
  if (sessionStorage.siteTenantId) {
    config.headers["tenantId"] = sessionStorage.siteTenantId;
  }

  config.headers["appId"] = sessionStorage.appId;  //后台需要的一个固定的appid
	return config

},error => {
  Message.error({
    message:'服务器异常'
  })
	return Promise.reject(error)
})

//http response 拦截器
axios.interceptors.response.use(res => {
  //这里可以与后台协商返回码，统一处理通用返回码,token过期的情况可在此处理
  if(res.data.returnCode && res.data.returnCode !== 200){//201，执行失败
    Message.error({
      message:res.data.returnMsg
    })
  }

  // debugger;
  if(res.data.returnCode === 110011){
    store.commit('LOGOUT');
    router.replace({
      path: '/login',
      query: {redirect: router.currentRoute.fullPath}
    });
  }

  // Content-Disposition: attachment;filename=gege20200327070541.xls
  // content-type: "application/vnd.ms-excel"
  if (res.headers["content-type"].indexOf("excel") > -1) {
    return res;
  }


  return res.data
},err => {
  console.log("err", err)
  const STATUS = err.response.status
  let msg = showStatus(STATUS)
  Message.error({
    message: msg
  });

  //token过期
  if (STATUS === 401) {
    // 401 清除token信息并跳转到登录页面
    store.commit('LOGOUT');
    router.replace({
      path: '/login',
      query: {redirect: router.currentRoute.fullPath}
    });
  }
  	//判断请求超时
	// let originalRequest = error.config;
	// if(error.code == 'ECONNABORTED' && error.message.indexOf('timeout')!=-1 && !originalRequest._retry){
	// 	console.log("error.code", error.code);
	// 	router.replace({
	// 		path: '/network_error',
	// 		query: {redirect: router.currentRoute.fullPath}
	// 	});
	// 	// return axios.request(originalRequest);
	// }
	return Promise.reject(err)

});

export default axios
